import { styled } from '@mui/material';
import { WarningAmberRounded } from '@mui/icons-material';
import React from 'react';
import { Colors, Text } from 'library';

export default function LateCancellationWarning() {
    return (
        <WarningBox>
            <WarningAmberRounded sx={{ color: Colors.terraCotta, fontSize: 20, flexShrink: 0, marginTop: '2px' }} />
            <Text variant="body2" textStyle={{ color: Colors.darkNavy }}>
                <b>Cancellation Policy: </b> For booked shifts cancelled within 2 hours of the shift start time, you
                will be responsible for paying for 2 hours of the shift.
            </Text>
        </WarningBox>
    );
}

const WarningBox = styled('div')({
    marginTop: 10,
    padding: '10px 14px',
    backgroundColor: Colors.lightTerraCotta,
    border: `1px solid ${Colors.terraCotta}`,
    borderRadius: 10,
    display: 'flex',
    alignItems: 'flex-start',
    gap: 10,
});
